import { apiFetch } from './client';

export interface CallerProfileRow {
  id: string;
  reseller_id: string;
  customer_id: string;
  ref_number: string;
  display_name: string | null;
  email: string | null;
  has_pin: boolean;
  points_balance: number;
  language: 'en' | 'he' | 'yi';
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface PhoneNumberRow {
  id: string;
  caller_id: string;
  e164: string;
  is_primary: boolean;
  created_at: string;
}

export interface CreateCallerBody {
  display_name?: string | null;
  email?: string | null;
  pin?: string | null;
  language?: 'en' | 'he' | 'yi';
  phone_numbers?: string[];
  customer_id?: string;
}

export type PatchCallerBody = Partial<{
  display_name: string | null;
  email: string | null;
  pin: string;
  clear_pin: boolean;
  language: 'en' | 'he' | 'yi';
  active: boolean;
}>;

export const callerProfiles = {
  list: (p: { search?: string; limit?: number; customer_id?: string } = {}) => {
    const q = new URLSearchParams();
    if (p.search) q.set('search', p.search);
    if (p.limit) q.set('limit', String(p.limit));
    if (p.customer_id) q.set('customer_id', p.customer_id);
    return apiFetch<{ rows: CallerProfileRow[] }>(`/api/caller-profiles?${q}`);
  },
  get: (id: string) => apiFetch<CallerProfileRow>(`/api/caller-profiles/${id}`),
  create: (body: CreateCallerBody) =>
    apiFetch<CallerProfileRow>('/api/caller-profiles', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: string, patch: PatchCallerBody) =>
    apiFetch<CallerProfileRow>(`/api/caller-profiles/${id}`, { method: 'PATCH', body: JSON.stringify(patch) }),
  remove: (id: string) =>
    apiFetch<void>(`/api/caller-profiles/${id}`, { method: 'DELETE' }),
  listPhones: (callerId: string) =>
    apiFetch<{ rows: PhoneNumberRow[] }>(`/api/caller-profiles/${callerId}/phone-numbers`),
  addPhone: (callerId: string, body: { e164: string; is_primary?: boolean }) =>
    apiFetch<PhoneNumberRow>(`/api/caller-profiles/${callerId}/phone-numbers`, {
      method: 'POST', body: JSON.stringify(body),
    }),
  removePhone: (callerId: string, phoneId: string) =>
    apiFetch<void>(`/api/caller-profiles/${callerId}/phone-numbers/${phoneId}`, { method: 'DELETE' }),
};
